import React from "react";
import { Button, Col, Row } from "reactstrap";
import { handleRequestError } from "../../../../../utils/helpers";
import { errorNotification } from "../../../../../utils/notifications";
import { cancelMembershipRequest } from "../../../../actions/partners";
import ConfirmModal from "../../../common/confirmModal/confirmModal";

interface Partner {
  idMembresiaSocio: string;
  idPersona: string;
  idPropietario: string;
}

interface Props {
  partner: Partner;
  reload: () => any;
}

class RecotizarMembresia extends React.Component<Props> {
  state = {
    isOpen: false,
    cancelMessages: [],
    cancelCharges: [],
    reasonToCancel: null,
    waiting: false
  };

  executeCancelMembership = () => {
    const { idMembresiaSocio: membresiaSocioId } = this.props.partner;

    this.setState({ waiting: true });

    cancelMembershipRequest({
      membresiaSocioId,
      motivo: "Recotización de condiciones de venta / reactivación",
      aplicarValidaciones: false,
      recotizacion: true
    })
      .then(({ data }) => {
        const { resultado } = data;

        if (!!resultado) {
          this.clearState();
          this.props.reload();
        } else {
          errorNotification(
            "Ocurrió un error al ejecutar la cancelación de membresía socio"
          );
        }
      })
      .catch((err: any) => {
        this.setState({ waiting: false });
        handleRequestError(err);
      });
  };

  clearState = () => {
    this.setState({
      isOpen: false,
      cancelMessages: [],
      cancelCharges: [],
      reasonToCancel: null,
      waiting: false
    });
  };

  render() {
    return (
      <div>
        <ConfirmModal
          title="Cancelar"
          message="Se cancelará la membresía socio actual y se perderá el número de membresía asignado.  ¿Desea continuar?"
          isOpen={this.state.isOpen}
          size="lg"
          style={{
            fontSize: "2.5em",
            fontWeight: "bold",
            backgroundColor: "#f7a548"
          }}
          waiting={!!this.state.waiting}
          ok={() => {
            this.executeCancelMembership();
          }}
          cancel={() => {
            this.setState({
              isOpen: false,
              waiting: false
            });
          }}
        />

        <Row className="p-0 m-0">
          <Col xs={4}>
            <Button
              block
              onClick={() => {
                this.setState({ isOpen: true });
              }}
              className="mt-3"
            >
              Cancelar membresía
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default RecotizarMembresia;
